const map = [
    ['fname', 'HotelName'],
    ['fbt', 'BoardTypes'],
    ['fstr', 'Stars'],
    ['fpt', 'PropertyTypes'],
    ['ffac', 'FacilityCodes'],
    ['fcd', 'ChildDestinations'],
    ['pr', 'PriceRange'],
    ['rr', 'RatingRange'],
    ['gsl', 'GeneralSaleDealsOnly']
];

export function format(filter) {
    const $injector = angular.element(document).injector();
    const $location = $injector.get('$location');
    const search = $location.search();

    map.forEach(function([queryStringName, filterName]) {
        let filterVal = filter[filterName];
        if (_.isObject(filterVal)) {
            filterVal = _.values(filterVal);
        }
        if (_.isArray(filterVal)) {
            filterVal = filterVal.join();
        }
        if (_.isBoolean(filterVal)) {
            if (filterVal) {
                search[queryStringName] = 1;
            } else {
                delete search[queryStringName];
            }
        } else if (filterVal && filterVal.length > 0) {
            search[queryStringName] = filterVal;
        } else {
            delete search[queryStringName];
        }
    });
    $location.search(search).replace();
}

export function parse() {
    const $injector = angular.element(document).injector();
    let $location = null;
    let search = [];
    if ($injector !== undefined) {
        $location = $injector.get('$location');
        search = $location.search();
    }
    const filter = {};

    map.forEach(function([queryStringName, filterName]) {
        const searchVal = search[queryStringName];
        if (queryStringName === 'fname') {
            filter[filterName] = searchVal;
        } else if (queryStringName === 'gsl') {
            filter[filterName] = searchVal === '1';
        } else if (searchVal && searchVal.length > 0) {
            const input = searchVal.split(',');
            filter[filterName] = isRange(queryStringName) ? minMax(input) : input;
        }
    });

    return filter;
}

function isRange(queryStringName) {
    return _.indexOf(['rr', 'pr'], queryStringName) > -1;
}

function minMax(input) {
    input = _.map(input, x => x ? parseFloat(x) : null);
    return {
        Min: input[0],
        Max: input[1],
    };
}
